module.exports = __webpack_public_path__ + "img/pick4.fee515ee.png";